module.exports = __webpack_public_path__ + "img/logo-mark.eed4fc4c.svg";